import { useAuthStore } from '@/Utility/auth/Auth';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/dash/settings/')({
  beforeLoad: ({
    location
  }) => {
    if (location.pathname === '/dash/settings') {
      const isAdmin = useAuthStore.getState()?.user?.isAdmin;
      if (isAdmin) {
        redirect({
          to: '/dash/settings/general/site-settings',
          throw: true
        });
      }
      redirect({
        to: '/dash/settings/management/profile',
        throw: true
      });
    }
  }
});